import Loadable from '../../components/loadable';

const EditGradingEvent = Loadable({
  loader: () => import('../../pages/gradings/edit_grading_event'),
  type: 'block',
});

angular.module('gym').value('EditGradingEvent', EditGradingEvent);
